import styled from 'styled-components';
import {rem} from 'polished';
import {Button} from 'global/styles/styles.js';

const baseFont = `12px`;
const S = {};

const FontFamily = ({theme: {$fontFamily}}) => `${$fontFamily}`;
const FwSemibold = ({theme: {$fwSemibold}}) => `${$fwSemibold}`;
const FwRegular = ({theme: {$fwRegular}}) => `${$fwRegular}`;

const InputErrorColor = ({theme: {$inputErrorColor}}) => `${$inputErrorColor}`;
const InputColor = ({theme: {$inputColor}}) => `${$inputColor}`;
const InputLabelColor = ({theme: {$inputLabelColor}}) => `${$inputLabelColor}`;
const InputPlaceholderColor = ({theme: {$inputPlaceholderColor}}) => `${$inputPlaceholderColor}`;
const InputBackgroundColor = ({theme: {$inputBackgroundColor}}) => `${$inputBackgroundColor}`;
const SubmitButtonTextColor = ({theme: {$submitButtonTextColor}}) => `${$submitButtonTextColor}`;
const FormBackgroundColor = ({theme: {$formBackgroundColor}}) => `${$formBackgroundColor}`;
const HeaderTextColor = ({theme: {$headerTextColor}}) => `${$headerTextColor}`;
const ResendTextColor = ({theme: {$resendTextColor}}) => `${$resendTextColor}`;
const ResendButtonColor = ({theme: {$resendButtonColor}}) => `${$resendButtonColor}`;
const StepperPrimaryColor = ({theme: {$stepperPrimaryColor}}) => `${$stepperPrimaryColor}`;
const StepperAccentColor = ({theme: {$stepperAccentColor}}) => `${$stepperAccentColor}`;
const StepperBackgroundColor = ({theme: {$stepperBackgroundColor}}) => `${$stepperBackgroundColor}`;
const StepperTextColor = ({theme: {$stepperTextColor}}) => `${$stepperTextColor}`;

S.RegisterWizardForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: ${FontFamily};
  background-color: ${FormBackgroundColor};
`;

S.LogoWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  width: 16.66rem;
  margin: ${rem('15px', baseFont)} 0;
  ${({ theme: { mqForMac } }) => mqForMac}{
    width: 7%;
  }
`;

S.Link = styled.a`
  display: flex;
  width: 100%;
  cursor: pointer;
`;

S.Logo = styled.img`
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
`;

S.LoginButton = styled.button`
  position: absolute;
  top: ${rem('15px', baseFont)};
  right: ${rem('15px', baseFont)};
  height: 3.5rem;
  font-weight: ${FwSemibold};
  padding: 0 ${rem('15px', baseFont)};
  border: 0;
  border-radius: 3px;
  text-transform: uppercase;
  font-size: 1.17rem;
`

S.InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

S.Input = styled.input`
  width: 100%;
  height: ${rem('48px', baseFont)};
  padding: 0 ${rem('12px', baseFont)};
  border: 1px solid ${props => props.hasError ? InputErrorColor : InputColor};
    
  border-radius: 4px;
  font-size: ${rem('14px', baseFont)};
  background: ${InputBackgroundColor};
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? InputErrorColor : InputColor};
  }

  &::placeholder {
    color: ${InputPlaceholderColor};
  }
`;

S.FloatingLabel = styled.span`
  position: absolute;
  top: -8px;
  left: 12px;
  background: ${InputBackgroundColor};
  padding: 0 4px;
  font-size: ${rem('11px', baseFont)};
  color: ${InputLabelColor};
  z-index: 1;
`;

S.CheckIcon = styled.span` 
  color: ${InputLabelColor};
  margin-left: auto; 
`;

S.ErrorText = styled.div` 
  color: ${InputErrorColor};
  font-size: 10px; 
  margin-top: 2px; 
`;

S.Title = styled.div`
  font-size: ${rem('26px', baseFont)};
  padding-top: 40px;
  padding-bottom: 40px;
  font-weight: ${FwRegular};
  text-align: center;
  color: ${HeaderTextColor};
`;

S.SubmitBtn = styled.button`
  width: 100%;
  height: ${rem('48px', baseFont)};
  background-color: ${InputErrorColor};
  color: ${SubmitButtonTextColor};
  border: none;
  border-radius: 4px;
  font-weight: ${FwSemibold};
  margin-top: 24px;
  cursor: pointer;
  text-transform: uppercase;

  &:disabled {
    opacity: 0.6; 
    cursor: not-allowed;
  }
`;

S.ResendText = styled.div`
  font-weight: ${FwRegular};
  font-size: ${rem('11px', baseFont)};
  color: ${ResendTextColor};
  margin-bottom: ${rem('15px', baseFont)};
`;

S.ResendCounter = styled.div`
  font-weight: ${FwRegular};
  font-size: ${rem('11px', baseFont)};
  color: ${ResendTextColor};
`;

S.ResendButton = styled.div`
  color: ${ResendButtonColor};
  font-weight: ${FwSemibold};
  cursor: pointer;
  font-size: ${rem('11px', baseFont)};
`;

S.Stepper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: ${props => props.stepsCount === 3 ? rem('420px', baseFont) : rem('280px', baseFont)};
  position: relative;
  padding-bottom: 40px;
`;

S.StepWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;

  &:not(:last-child):after {
    content: '';
    position: absolute;
    top: ${rem('13px', baseFont)}; 
    left: 50%; 
    width: 100%; 
    height: 1px;
    background-color: ${StepperPrimaryColor};
    z-index: 1;
  }
`;

S.Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  cursor: ${props => props.hasPointer ? 'pointer' : 'default'};
`;

S.StepCircle = styled.div`
  width: ${rem('26px', baseFont)};
  height: ${rem('26px', baseFont)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.isActive ? StepperAccentColor : StepperBackgroundColor};
  border: 1px solid ${props => props.isActive ? StepperAccentColor : StepperPrimaryColor};
  color: ${props => props.isActive ? StepperTextColor : StepperPrimaryColor};
  z-index: 2;
  transition: all 0.2s;
`;

S.StepLabel = styled.div`
  margin-top: ${rem('8px', baseFont)};
  font-size: ${rem('10px', baseFont)};
  text-align: center;
  color: ${props => props.isActive ? StepperAccentColor : 'rgba(0, 0, 0, 0.38)'};
  font-weight: ${props => props.isCurrent ? FwSemibold : FwRegular};
  width: 100%;
`;

S.CloseIcon = styled.div`
    position: absolute;
    right: ${rem('16px', baseFont)};
    top: ${rem('10px', baseFont)};
    padding: 0;
    transform: none;
    line-height: 1;
    cursor: pointer;
    color: #000;
    &:before{
      content: "\\00d7";
      font-size: ${rem('35px', baseFont)};
    }
`;

S.HideIframe = styled.iframe`
    display: none;
`;


S.Dialog = styled.div`
   width:  ${rem('335px', baseFont)};
   padding: ${rem('16px', baseFont)};
   box-shadow: 0 19px 38px #00000042;

`;

S.DialogBtnOk = styled(Button)`
 width:  ${rem('142px', baseFont)};
 min-height:  ${rem('42px', baseFont)};
 text-transform: uppercase;
 color: #fff;
 background-color: #C62828;
 border-radius: 3px;
 font-weight: ${FwSemibold};
`;

S.DialogBtnCancel = styled(S.DialogBtnOk)`
 color: #C62828;
 background-color: #fff;
 border: 1px solid #C62828;
`;

S.DialogText =styled.div`
  font-size: ${rem('13px', baseFont)};
  color: #000;
      text-align: center;
`;

S.BellIcon = styled.div`
  width:  ${rem('32px', baseFont)};
`;

S.ConfirmationModal = styled.div`
   display: flex;
   flex-direction: column;
   padding: ${rem('40px', baseFont)};
`;

S.ConfirmationMsg = styled.div`
   font-size: ${rem('20px', baseFont)};
   color: #000;
`;

S.ConfirmationCloseBtn = styled(Button)`
    background-color: #CE0006;
    height: ${rem('44px', baseFont)};
    font-size: 1rem;
    font-weight: ${FwSemibold};
    padding: 0;
    width: ${rem('125px', baseFont)};
    margin-bottom: 0;
    margin-top: 1.5rem;
    color: #fff;
    cursor: pointer;
    border: 2px solid #CE0006;
    border-radius: 3px;
    text-transform: uppercase;
    margin-left: auto;
    margin-right: auto;
    display: block;
`;

S.BannerWrapper = styled.div`
  position:relative;
`

S.PrevStepBtn = styled(Button)`
    display:flex;
    background-color: transparent;
    align-items: center;
    position: absolute;
    padding: 0;
    bottom: ${rem('-20px', baseFont)};
    left: ${rem('5px', baseFont)};
`;

S.PrevIcon = styled.div`
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: ${rem('16px', baseFont)};
    height: ${rem('14px', baseFont)};
    display: flex;
    line-height: 1;
     & svg{
     width: 100%;
        & path{
            fill: #000 !important;
        }
    }
`;

S.FooterWrapper = styled.div`
  width: 100%;
  margin-top: ${rem('40px', baseFont)};
`;

export default S;
